import logo from './resources/night.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
           Oh... you're here a bit too soon :')
        </p>
      </header>
    </div>
  );
}

export default App;
